@if (model$ | async; as model) {
  <div class="container-left" id="landing-content-left">
    <div class="icon">
      <span class="icon-learniz-light-bulb"></span>
    </div>
    <h2 [innerHTML]="'learniz.landing-page.content-title' | wording"></h2>
  </div>
  <div class="container-right" id="landing-content-right">
    <div class="contents">
      <div class="contents-description">
        <p [innerHTML]="model.context.description | safeHtml"></p>
      </div>
      @if (model.context.requirements) {
        <div class="contents-requirement">
          <h3 [innerHTML]="'learniz.landing-page.requirement-title' | wording"></h3>
          <div class="contents-description">
            <p [innerHTML]="model.context.requirements | safeHtml"></p>
          </div>
        </div>
      }
    </div>
  </div>
}
